module.exports = __webpack_public_path__ + "static/img/图层8.9583cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/4/图层8.png
// module id = OfYR
// module chunks = 1